import {
  NetworkConfig,
  NetworkInstance,
  NetworkRequestConfig,
  NetworkResponse
} from './network-factory';

class FetchAdapter implements NetworkInstance {
  private config: NetworkConfig;

  constructor(config: NetworkConfig) {
    this.config = config;
  }

  public get = (
    url: string,
    { params = {}, config = {} }: NetworkRequestConfig = {}
  ): Promise<NetworkResponse> =>
    fetch(url, {
      method: 'GET',
      ...this.config,
      ...config,
      params
    }).then(response => response.json());

  public post = (
    url: string,
    { data = {}, config = {} }: NetworkRequestConfig = {}
  ): Promise<NetworkResponse> =>
    fetch(url, {
      method: 'POST',
      data,
      ...this.config,
      ...config,
      body: JSON.stringify(data)
    }).then(response => response.json());

  public put = (
    url: string,
    { data = {}, config = {} }: NetworkRequestConfig = {}
  ): Promise<NetworkResponse> =>
    fetch(url, {
      method: 'PUT',
      body: JSON.stringify(data),
      ...this.config,
      ...config
    }).then(response => response.json());

  public delete = (
    url: string,
    { data = {}, config = {} }: NetworkRequestConfig = {}
  ): Promise<NetworkResponse> =>
    fetch(url, {
      method: 'DELETE',
      ...config,
      data
    }).then(response => response.json());
}

export default FetchAdapter;
